// extracted by mini-css-extract-plugin
export default {"errorCompanyExist":"eodh8WRYP93QElbGVwJ5","alertInfo":"RWcaDUEb2KWqIWiFJ_nC","organizer":"wlYyTiuSjhOhuuhUH2xa","createOrgaLink":"tcFJpPoC6pTy9dPWERbV"};